"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _react = _interopRequireDefault(require("react"));

var _sarsLogoWhite = _interopRequireDefault(require("./Assets/sars-logo-white.png"));

var _sarsLogoWhiteSmall = _interopRequireDefault(require("./Assets/sars-logo-white-small.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SARSHeader = function SARSHeader(_ref) {
  var onLogoClick = _ref.onLogoClick,
      pageTitle = _ref.pageTitle,
      pageTitleMobile = _ref.pageTitleMobile;
  return /*#__PURE__*/_react.default.createElement("header", {
    className: "navbar navbar-inverse navbar-fixed-top",
    style: {
      textAlign: "left !important",
      backgroundImage: "linear-gradient(to right, rgb(0,56,101) , rgb(0,98,155))",
      position: "sticky",
      top: 0,
      zIndex: 1000
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container",
    style: {
      marginLeft: "5px !important"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    justify: "flex-end",
    height: "12vh",
    sx: {
      display: {
        xs: "block",
        sm: "None",
        md: "None"
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    sx: {
      paddingTop: "1vh"
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    onClick: onLogoClick,
    src: _sarsLogoWhiteSmall.default,
    alt: "SARS Logo",
    style: {
      height: "5vh",
      padding: "1%"
    }
  }), /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h2",
    style: {
      color: "white",
      padding: "1%",
      fontSize: "20px"
    }
  }, pageTitleMobile === "" ? pageTitle : pageTitleMobile)))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    sx: {
      display: {
        xs: "none",
        sm: "block",
        md: "block"
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    onClick: onLogoClick,
    src: _sarsLogoWhite.default,
    alt: "SARS Logo",
    style: {
      height: "10vh",
      padding: "2%"
    }
  }), /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h1",
    style: {
      color: "white",
      padding: "0",
      fontSize: "40px"
    }
  }, pageTitle))))));
};

var _default = SARSHeader;
exports.default = _default;